// Listen for parent page data via postMessage
export const initParentPageListener = () => {
  window.parentPageData = {};

  // console.log('[iframe] Initializing parent page listener...');

  window.addEventListener('message', (event) => {
    // console.log('[iframe] Received postMessage from:', event.origin);
    // console.log('[iframe] Message data:', event.data);

    if (event.data && event.data.type === 'PARENT_PAGE_DATA') {
      // console.log('[iframe] ✅ PARENT_PAGE_DATA received!');
      // console.log('[iframe] Page URL:', event.data.page_url);
      // console.log('[iframe] Page Title:', event.data.page_title);
      // console.log('[iframe] UTM Source:', event.data.utm_source);
      // console.log('[iframe] UTM Campaign:', event.data.utm_campaign);
      // console.log('[iframe] IP Address:', event.data.ip_address);

      // Store in window object
      window.parentPageData = {
        page_url: event.data.page_url,
        page_title: event.data.page_title,
        utm_source: event.data.utm_source,
        utm_medium: event.data.utm_medium,
        utm_campaign: event.data.utm_campaign,
        utm_term: event.data.utm_term,
        utm_content: event.data.utm_content,
        ip_address: event.data.ip_address
      };

      // console.log('[iframe] Stored in window.parentPageData:', window.parentPageData);

      // Also store in sessionStorage as backup
      try {
        sessionStorage.setItem('parent_page_url', event.data.page_url || '');
        sessionStorage.setItem('parent_page_title', event.data.page_title || '');
        sessionStorage.setItem('utm_source', event.data.utm_source || '');
        sessionStorage.setItem('utm_medium', event.data.utm_medium || '');
        sessionStorage.setItem('utm_campaign', event.data.utm_campaign || '');
        sessionStorage.setItem('utm_term', event.data.utm_term || '');
        sessionStorage.setItem('utm_content', event.data.utm_content || '');
        sessionStorage.setItem('ip_address', event.data.ip_address || '');
        // console.log('[iframe] ✅ Saved to sessionStorage');
      } catch (e) {
        // console.error('[iframe] ❌ Could not save to sessionStorage:', e);
      }
    } else {
      // console.log('[iframe] Message type:', event.data?.type || 'unknown');
    }
  });

  // console.log('[iframe] ✅ Parent page listener initialized and ready');

  // Log current state after a delay to see if data arrives
  // setTimeout(() => {
  //   console.log('[iframe] Current window.parentPageData:', window.parentPageData);
  //   console.log('[iframe] SessionStorage utm_source:', sessionStorage.getItem('utm_source'));
  //   console.log('[iframe] SessionStorage page_url:', sessionStorage.getItem('parent_page_url'));
  // }, 2000);
};
